import React, { useState, useMemo } from "react";
import clsx from "clsx";
import {
  OrganizationBox,
  ORGS_DISPLAY_LIMIT,
  RemainderBox,
} from "./organization.box";

import "./organizations.section.scss";
import { ZeroStateMessage } from "../../../../../components/zero-state-message/zero-state-message";
import { ProgramOrgsModal } from "./program-orgs.modal";

export const OrganizationsSection = ({ data, className }) => {
  const { organizations, title } = data;
  const [programOrgsModalOpen, setProgramOrgsModalOpen] = useState();

  const firstThreeOrganizations = useMemo(() => {
    if (!organizations || organizations.length <= ORGS_DISPLAY_LIMIT) {
      return organizations;
    }
    return organizations.slice(0, ORGS_DISPLAY_LIMIT);
  }, [organizations]);

  return (
    <div className={clsx("organizations-section", className)}>
      <h2>Organizations</h2>
      <div className="box-section">
        {organizations && organizations.length > 0 ? (
          <>
            {firstThreeOrganizations.map((org) => (
              <OrganizationBox
                key={org.id}
                organization={org}
                breadcrumbLabel={org.name}
              />
            ))}
            <RemainderBox
              organizations={organizations}
              onClick={() => setProgramOrgsModalOpen(true)}
            />
          </>
        ) : (
          <ZeroStateMessage text="There are no organizations configured with this program." />
        )}
      </div>
      {organizations && organizations.length > ORGS_DISPLAY_LIMIT && (
        <ProgramOrgsModal
          open={programOrgsModalOpen}
          program={data}
          onClose={() => setProgramOrgsModalOpen()}
          breadcrumbLabel={title}
        />
      )}
    </div>
  );
};
